import { render, staticRenderFns } from "./officialAction.vue?vue&type=template&id=4612c49a&scoped=true&"
import script from "./officialAction.vue?vue&type=script&lang=js&"
export * from "./officialAction.vue?vue&type=script&lang=js&"
import style0 from "./officialAction.vue?vue&type=style&index=0&id=4612c49a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4612c49a",
  null
  
)

export default component.exports